import { RouteId, RouteConfig } from '../../../types';
import Orders from '../Orders';
import DashboardIcon from '@material-ui/icons/Dashboard';

const routePrefix = '/dashboard';

const routes: RouteConfig[] = [
  {
    Component: Orders,
    path: `${routePrefix}/orders`,
    getTitle: () => 'Activate or Transfer Master Codes',
    getBreadcrumbs: () => [
      { name: 'Dashboard', path: routePrefix, Icon: DashboardIcon },
      { name: 'Activate or Transfer Master Codes', path: `${routePrefix}/orders` }
    ],
    id: RouteId.DASHBOARD_ORDERS,
    privileges: []
  }
];

const getRoutes = (): RouteConfig[] => {
  return routes;
};

export default getRoutes;
